import axios from 'axios';

const getMyConversations = () => axios.get('/conversations');

const getClientConversation = companyId =>
  axios.get(`/conversations/get_client_conversation?company_id=${companyId}`);

const sendMessage = ({
  text,
  conversationId,
  hasReminder,
  messageTag,
  scheduledTime,
  isLog,
  messageThreadId = null,
}) =>
  axios.post('/conversations/send_message', {
    text,
    conversation_id: conversationId,
    has_reminder: hasReminder,
    message_tag: messageTag,
    scheduled_time: scheduledTime,
    is_log: isLog,
    message_thread_id: messageThreadId,
  });

const deleteScheduledMessage = messageId =>
  axios.post('/conversations/delete_scheduled_message', {
    message_id: messageId,
  });

const removeAutoReminder = id =>
  axios.post(`/conversations/${id}/remove_auto_reminder`);

const editScheduledMessage = (messageId, scheduledTime) =>
  axios.post('/conversations/edit_scheduled_message', {
    message_id: messageId,
    scheduled_time: scheduledTime,
  });

const updateConversationAsSeen = conversationId =>
  axios.get(
    `/conversations/update_conversation_as_seen?conversation_id=${conversationId}`,
  );
const updateThreadAsSeen = ({ conversationId, threadId }) =>
  axios.get(
    `/conversations/update_thread_as_seen?conversation_id=${conversationId}&thread_id=${threadId}`,
  );

const updateConversation = conversation =>
  axios.post(`/conversations/update_conversation`, conversation);

const exportConversation = (conversationId, startDate, endDate) =>
  axios.get(`/conversations/export_conversation`, {
    params: {
      id: conversationId,
      start_date: startDate || undefined,
      end_date: endDate || undefined,
    },
  });

const exportConversationAsPDF = (conversationId, startDate, endDate) =>
  axios.get(`/conversations/export_conversation_as_pdf`, {
    params: {
      id: conversationId,
      start_date: startDate || undefined,
      end_date: endDate || undefined,
    },
  });

const downloadAttachment = link =>
  axios.post('/conversations/download_attachment', {
    link,
  });

const getFolders = path =>
  axios.post('/conversations/get_folders', {
    path,
  });

const renameItem = ({ newName, messageId, link }) =>
  axios.post('/conversations/rename_item', {
    new_name: newName,
    message_id: messageId,
    link,
  });

const copyItem = ({ newPath, link }) =>
  axios.post('/conversations/copy_item', {
    new_path: newPath,
    link,
  });
const markAsUnseen = id =>
  axios.post('/conversations/mark_as_unseen', {
    id,
  });

const getConversation = id => axios.get(`/conversations/${id}`);

const getThreadMessages = (conversationId, messageThreadId) =>
  axios.get(
    `/conversations/thread_messages?id=${conversationId}&message_thread_id=${messageThreadId}`,
  );

const getMetrics = (startDate, endDate) =>
  axios.get(`/conversations/metrics`, {
    params: {
      start_date: startDate,
      end_date: endDate,
    },
  });

const getUnseenMessages = (limit, offset) =>
  axios.get(`/conversations/unseen_messages`, {
    params: {
      limit: limit,
      offset: offset,
    },
  });

const getIncomingMessages = (limit, offset) =>
  axios.get(`/conversations/incoming`, {
    params: {
      limit: limit,
      offset: offset,
    },
  });

const getOutgoingMessages = (limit, offset) =>
  axios.get(`/conversations/outgoing`, {
    params: {
      limit: limit,
      offset: offset,
    },
  });

export default {
  getMyConversations,
  getClientConversation,
  sendMessage,
  deleteScheduledMessage,
  editScheduledMessage,
  updateConversationAsSeen,
  updateConversation,
  downloadAttachment,
  markAsUnseen,
  getConversation,
  getMetrics,
  getUnseenMessages,
  getIncomingMessages,
  getOutgoingMessages,
  renameItem,
  getFolders,
  copyItem,
  exportConversation,
  exportConversationAsPDF,
  removeAutoReminder,
  getThreadMessages,
  updateThreadAsSeen,
};
